/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import ActionCreator from '../action-creator';

export const ActionCreators = {
  RequestAntennas: new ActionCreator<'RequestAntennas', any>('RequestAntennas'),
  ReceivedAntennasSuccess: new ActionCreator<'ReceivedAntennasSuccess', any>('ReceivedAntennasSuccess'),
  ReceivedAntennasError: new ActionCreator<'ReceivedAntennasError', any>('ReceivedAntennasError'),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function requestAntennas() {
  return ActionCreators.RequestAntennas.create();
}
